import $ from 'jquery';

export default function menuMobile() {
  
  function init() {
    $('.hamburger').on('click', function() {
      $(this).toggleClass('open');
      $('.pushmenu').toggleClass('pushmenu-push-left');
      
      if ($('#nav .language').length > 0) {
        //lo switch delle lingue � gi� presente all'interno del div "#nav"
      } else {
        $(".language").clone().removeClass('d-none d-lg-block').addClass('d-lg-none').appendTo('#nav');
        
        if ($('.btn-prenota').length > 0) {
          $(".btn-prenota").clone().removeClass('d-none d-lg-block').addClass('d-lg-none').appendTo('.language');
        }
      }
    });
    
    $('.navigation .navigation__icon').on('click', function(e) {
      e.preventDefault();
      $(this).parent('.navigation__item').toggleClass('open');
    });
  }
  
  $( document ).ready(function() {
    if($('.hamburger').length > 0) {
      init();
    }
  });
  
}


// WEBPACK FOOTER //
// ./src/assets/js/menu-mobile.js